import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LanguageDetails } from '../../../models/general.model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from '../../../services/app.service';
import { MasterService } from '../../../services/master.service';
import { DashboardService } from '../../../services/dashboard.service';

@Component({
  selector: 'app-dashboard-tiles-edit-form',
  templateUrl: './dashboard-tiles-edit-form.component.html',
  styleUrls: ['./dashboard-tiles-edit-form.component.scss']
})
export class DashboardTilesEditFormComponent implements OnInit {
@Output() closeDialogue = new EventEmitter();
  
  rmList : any = [];
  dialogHeader : string = "";

  fhMapping : any = [];
  generalId : Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;
  languageDetails = new LanguageDetails();

  loadingIndicator = false;
  reorderable = true;

  translations: any;

  dashboardTiles: any = [];
  
  constructor( @Inject(MAT_DIALOG_DATA)
  public data: { Id : 0, type: "" },
  public dialog: MatDialog,
  private formBuilder: FormBuilder,
  public appService: AppService,
  private masterService: MasterService,
  public dashService: DashboardService,
  public dialogRef: MatDialogRef<DashboardTilesEditFormComponent>){
    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
        Code :{},
        Description: {}
    };

    this.formGroup = this.formBuilder.group({
        Code:['',Validators.required],
        Description: ['', Validators.required]
        });
    this.generalId = this.data.Id;
  }
  
  ngOnInit() {
    this.all(); 
  }

  all(): void {
    this.dashService.all(this.data.Id).subscribe(
      res => this.allSuccess(res),
      error => this.apiFaillure(error)
    );
  }

  allSuccess(res): void {
    this.appService.hideLoading();
    if (res.Status) {
      if (JSON.parse(res.Data).length > 0){
        this.dashboardTiles = JSON.parse(res.Data);
        
      }
      else 
        this.apiFaillure(this.translations[res.Message]);
    }
  }

  formatOrderCount(_number, _sep) {
    _number = typeof _number != "undefined" && _number > 0 ? _number : "0";
    _number = _number.toString().replace(new RegExp("^(\\d{" + (_number.length % 3 ? _number.length % 3 : 0) + "})(\\d{3})", "g"), "$1 $2").replace(/(\d{3})+?/gi, _sep + "$1").trim();
    if(_number.indexOf(' ') > -1) {
        _number = _number.toString().replace(' ', '');
    }
    if(_number.indexOf(',') == 0) {
        _number = _number.substr(1);
    }
    return _number;
  }

  setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
  } 
  
  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(this.translations.hdError, error);
  }

  close(){
    this.dialogRef.close();
  }

  onChange(tile){
    this.dashService.save(tile).subscribe(
      res => this.saveSuccess(res),
      error => this.apiFaillure(error)
    );
  }

  save(): void{
    this.appService.showLoading();
    this.dashService.save(this.dashboardTiles).subscribe(
      res => this.saveSuccess(res),
      error => this.apiFaillure(error)
    );
  }

  saveSuccess(res): void {
    this.appService.hideLoading();
    if (res.Status == 1) {
    this.appService.showDialogue(this.translations.hdSuccess, this.translations[res.Message]).afterClosed().subscribe(result => {
        if (result) {
          this.close();
        }          
    });    
    } else if (res.Status == -1) {
      this.apiFaillure(res.Message);
    }
  }

  filterTiles(type){
     return this.dashboardTiles.filter(x => x.Type == type).length > 0 ? this.dashboardTiles.filter(x => x.Type == type) : [];
  }
  
}






// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/dashboard-tiles-edit-form/dashboard-tiles-edit-form.component.ts